import { Route, Routes } from 'react-router-dom';
import './App.css';
import DashLayout from './components/admin/DashLayout';
import Dashboard from './components/admin/Dashboard';
import AllUsers from './components/admin/AllUsers';

function App() {

  return (
    <>

      <Routes>
        <Route path='/dashboard/admin' >
          <Route index element={
            <DashLayout>

              <Dashboard />
            </DashLayout>
          } />
          <Route path='all-users' element={<DashLayout>
            <AllUsers />
          </DashLayout>} />

        </Route>

      </Routes>
    </>
  )
}

export default App;
